module.exports = __webpack_public_path__ + "static/img/pay-bg.47089f9d.png";